/**
 * Domain enums — the member names are identical to the Prisma enums in
 * 03 §2, so a value read from the database is assignable to these types
 * without translation.
 */
/* ────────────────────────────── staff ─────────────────────────────────── */
/** Prisma enum `UserRole` (03 §2). */
export const UserRole = {
    ADMIN: 'ADMIN',
    TA: 'TA',
};
export const USER_ROLES = ['ADMIN', 'TA'];
/**
 * Alias kept because the build contract names this enum `Role`.
 * The Prisma model calls it `UserRole`; both names denote the same values.
 */
export const Role = UserRole;
/* ───────────────────────────── students ───────────────────────────────── */
export const StudentStatus = {
    ACTIVE: 'ACTIVE',
    SUSPENDED: 'SUSPENDED',
};
export const STUDENT_STATUSES = ['ACTIVE', 'SUSPENDED'];
/* ───────────────────────────── sections ───────────────────────────────── */
export const SectionStatus = {
    DRAFT: 'DRAFT',
    OPEN: 'OPEN',
    CLOSED: 'CLOSED',
};
export const SECTION_STATUSES = [
    'DRAFT',
    'OPEN',
    'CLOSED',
];
/**
 * Live phase of an OPEN section (04 §6.3 `section.phase`). This is derived
 * from `openedAt` + the section's thresholds, never stored — see `phase.ts`.
 */
export const Phase = {
    PRESENT: 'PRESENT',
    LATE: 'LATE',
    CLOSED: 'CLOSED',
};
export const PHASES = ['PRESENT', 'LATE', 'CLOSED'];
/* ──────────────────────────── attendance ──────────────────────────────── */
export const AttendanceStatus = {
    PRESENT: 'PRESENT',
    LATE: 'LATE',
    ABSENT: 'ABSENT',
    EXCUSED: 'EXCUSED',
};
export const ATTENDANCE_STATUSES = [
    'PRESENT',
    'LATE',
    'ABSENT',
    'EXCUSED',
];
export const AttendanceSource = {
    SCAN: 'SCAN',
    MANUAL: 'MANUAL',
};
export const ATTENDANCE_SOURCES = ['SCAN', 'MANUAL'];
/** Result of a random spot-check on one row (02 §6.2). */
export const SpotCheckResult = {
    PASSED: 'PASSED',
    FAILED: 'FAILED',
};
export const SPOT_CHECK_RESULTS = [
    'PASSED',
    'FAILED',
];
/* ────────────────────────────── devices ───────────────────────────────── */
export const DeviceStatus = {
    ACTIVE: 'ACTIVE',
    PENDING_APPROVAL: 'PENDING_APPROVAL',
    REVOKED: 'REVOKED',
};
export const DEVICE_STATUSES = [
    'ACTIVE',
    'PENDING_APPROVAL',
    'REVOKED',
];
/* ────────────────────────────── grading ──────────────────────────────── */
export const BelowThresholdMode = {
    LINEAR: 'LINEAR',
    ZERO: 'ZERO',
    STEP: 'STEP',
};
export const BELOW_THRESHOLD_MODES = [
    'LINEAR',
    'ZERO',
    'STEP',
];
/** Grade effect of a missed mid-lecture checkpoint (02 §6.3, 03 §2). */
export const CheckpointMode = {
    /** Only flag the row. */
    FLAG: 'FLAG',
    /** Downgrade PRESENT to LATE. */
    LATE: 'LATE',
};
export const CHECKPOINT_MODES = ['FLAG', 'LATE'];
/* ─────────────────────────────── audit ───────────────────────────────── */
export const ActorType = {
    USER: 'USER',
    STUDENT: 'STUDENT',
    SYSTEM: 'SYSTEM',
};
export const ACTOR_TYPES = ['USER', 'STUDENT', 'SYSTEM'];
//# sourceMappingURL=enums.js.map